import classNames from 'classnames';

import { MinusIcon, PlusIcon } from '../../icons';

import styles from './_index.module.scss';

export interface MinusPlusButtonsProps {
  disableMinusButton?: boolean;
  disablePlusButton?: boolean;
  hasMinusButton?: boolean;
  hasPlusButton?: boolean;
  isNeutral?: boolean;
  onClickMinus?: () => void;
  onClickPlus?: () => void;
}

const MinusPlusButtons = ({
  disableMinusButton,
  disablePlusButton,
  hasMinusButton = true,
  hasPlusButton = true,
  isNeutral,
  onClickMinus,
  onClickPlus,
}: MinusPlusButtonsProps) => {
  return (
    <span className={styles['minus-plus-buttons']}>
      {hasMinusButton && (
        <button
          className={classNames(styles[`button-minus-icon`], { [styles['is-neutral']]: isNeutral })}
          data-testid="button-minus-icon"
          disabled={disableMinusButton}
          onClick={onClickMinus}
        >
          <MinusIcon />
        </button>
      )}
      {hasPlusButton && (
        <button
          className={classNames(styles[`button-plus-icon`], { [styles['is-neutral']]: isNeutral })}
          data-testid="button-plus-icon"
          disabled={disablePlusButton}
          onClick={onClickPlus}
        >
          <PlusIcon />
        </button>
      )}
    </span>
  );
};

export default MinusPlusButtons;
